module.exports = "/_next/static/images/Certhub-cea17a25807d217bf695a7dc639fff43.svg";